const isNested = (value) => Object.prototype.toString.call(value) === '[object Object]';

const flattenInto = (target, obj, roots, sep) => {
    Object.keys(obj).forEach((prop) => {
        const path = roots.concat([prop]);
        if (isNested(obj[prop])) {
            flattenInto(target, obj[prop], path, sep);
        } else {
            target[path.join(sep)] = obj[prop];
        }
    });
    return target;
};

/**
 * One row per entry, nested keys joined by the separator. A single accumulator per row: copying the
 * accumulator once per property made the cost grow with the square of the column count, which is
 * what made exporting-capable tables slow on every redraw.
 */
export const flattenObj = (arr, sep = '.') => {
    const rows = [];

    for (let i = 0; i < arr.length; i++) {
        if (arr[i] !== undefined) {
            rows.push(flattenInto({}, arr[i], [], sep));
        }
    }

    return rows;
};
